import axios from "axios";
import axiosRetry from "axios-retry";
import store from "../store";

axiosRetry(axios, {
    retries: 5,
    retryDelay: (retryCount) => {
        return retryCount * 500;
    },
});

axios.interceptors.request.use(async config => {

        if(store.getters.auth0Authenticated) {
            config.headers.Authorization = `Bearer ${store.getters.auth0Token}`;
        }
        return config;

    }, error => {
        return Promise.reject(error);
    },
);

export default axios;
